// Paises.jsx
import React, { useState, useMemo, useEffect } from "react";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import Table from "../../../components/common/Table/Table";
import Button from "../../../components/common/Button/Button";
import InputSearch from "../../../components/common/Inputs/InputSearch/InputSearch";
import { FiDownload } from "react-icons/fi";
import { LuArrowDownUp } from "react-icons/lu";
import { getApiInstance } from "../../../utils/api";
import { mapList } from "../../../utils/utils";
import { useZone } from "../../../context/ZoneContext";

const columnasPaises = [
    {
    key: "codPais",
    label: "País",
    sortable: true,
    visible: false
  },
  {
    key: "pais",
    label: "País",
    sortable: true,
    visible: true
  }
];

const filterFields = [
  { key: "pais", label: "País", type: "multiselect" },
];

export default function Paises() {
  const [paises, setPaises] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { selectedZone } = useZone();

  useEffect(() => {
    fetchPaises();
  }, [selectedZone]);

  const fetchPaises = async () => {
    setLoading(true);
    const api = getApiInstance();

    try {
      let paisesData = [];

      const response = await api.get(`/api/Paises/GetPaisesByZona/${selectedZone.value}`);
      paisesData = response.data;

      console.log("Paises data fetched:", paisesData);

      //setPaises(mapList(paisesData, "pais", "codPais", "codPais"));
      setPaises(paisesData);
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar los países. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
 
  if (error)
    return <div className="muebles-pages__error-message">Error: {error}</div>;

  return (
    <PageLayout
      title="Países"
      subtitle="Gestión de países disponibles en el sistema"
    >
      <Table
        columns={columnasPaises}
        dataTable={paises}
        showCheckboxes={true}
        actions={["Eliminar", "Editar"]}
        noResultsMessage="No se han encontrado países."
        searchTerms={["País"]}
        formElements={[
          {
            elements: [
              {
                name: "pais",
                type: "text",
                label: "País",
                placeholder: "Introduce el país",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
              {
                name: "codZona",
                type: "number",
                label: "Zona",
                placeholder: "Introduce la zona",
                required: true,
                disabled: false,
                labelVisible: false,
                visible: false,
                defaultValue: selectedZone.value
              }
            ],
          },
        ]}
        filterFields={filterFields}
        loading={loading}
        elementName="País"
        keyProp="codPais"
        sortProp="pais"
        addApiUrl="/api/Paises/SetPais"
        editApiUrl="/api/Paises/EditPais"
        deleteApiUrl="/api/Paises/DeletePais"
      />
    </PageLayout>
  );
}
